export default "__VITE_ASSET__lpG46Tws__"